import TextEllipsis from "@/components/Elements/TextEllipsis";

const DescriptionListItem = ({ label, labelEllipsis, id, content }) => {
  return (
    <>
      <dt id={id}>
        {labelEllipsis ? <TextEllipsis>{label}</TextEllipsis> : label}
      </dt>
      <dd aria-labelledby={id}>{content}</dd>
    </>
  );
};

export default DescriptionListItem;
